import styled from "styled-components";

import { handleHeadingSize, handleHeadingSpacing } from "./helpers";

export const StyledHeading = styled.span`
    ${({ size }) => handleHeadingSize({ size })}
    ${({ bottomSpacing }) => handleHeadingSpacing({ bottomSpacing })}
    ${({ headingColor }) => headingColor && `color: ${headingColor};`}
    text-align: ${({ alignment }) => (alignment ? alignment : "left")};
`;
